const MOBILE_KC_AT_COOKIE = 'erisedMobileKCAT';
const MOBILE_KC_RT_COOKIE = 'erisedMobileKCRT';
const MOBILE_KC_IT_COOKIE = 'erisedMobileKCIT';
const MOBILE_KC_ORIGIN_COOKIE = 'erisedMobileKCOrigin';

function readCookie(name) {
  try {
    const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : '';
  } catch (error) {
    return '';
  }
}

export function getMobileBootstrapInitOptions() {
  try {
    const token = readCookie(MOBILE_KC_AT_COOKIE);
    const refreshToken = readCookie(MOBILE_KC_RT_COOKIE);
    const idToken = readCookie(MOBILE_KC_IT_COOKIE);
    if (!token || !refreshToken) return {};

    return {
      token,
      refreshToken,
      idToken: idToken || undefined
    };
  } catch (error) {
    return {};
  }
}

function resolveCookieDomain() {
  const host = (window.location.hostname || '').toLowerCase();
  if (host.endsWith('.doitforme.club')) return '.doitforme.club';
  if (host.endsWith('.doitforme.eu')) return '.doitforme.eu';
  return host;
}

function clearCookieEverywhere(name) {
  const host = (window.location.hostname || '').toLowerCase();
  const domain = resolveCookieDomain();
  const candidates = [host, domain, '.doitforme.club', '.doitforme.eu'];
  document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax; Secure`;
  candidates.forEach((candidate) => {
    document.cookie = `${name}=; path=/; domain=${candidate}; max-age=0; SameSite=Lax; Secure`;
  });
}

export function clearMobileBootstrapCookies() {
  const cookieNames = String(document.cookie || '')
    .split(';')
    .map((entry) => entry.trim().split('=')[0])
    .filter(Boolean)
    .filter((name) => !String(name || '').toLowerCase().startsWith('silktide'));

  cookieNames.forEach(clearCookieEverywhere);
  clearCookieEverywhere(MOBILE_KC_AT_COOKIE);
  clearCookieEverywhere(MOBILE_KC_RT_COOKIE);
  clearCookieEverywhere(MOBILE_KC_IT_COOKIE);
  clearCookieEverywhere(MOBILE_KC_ORIGIN_COOKIE);
}
